import React from 'react'
import styled from 'styled-components'

import creationImg from '@/assets/images/use_case_creation.gif'
import messagingImg from '@/assets/images/use_case_messaging.gif'
import postingImg from '@/assets/images/use_case_posting.gif'
import { mobile } from '@/utils/media-query'

import { SectionBlock } from './section'

type UseCase = {
  title: string
  description: React.ReactNode
  imgSrc: string
}

const ItemsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  @media ${mobile.query} {
    flex-direction: column;
    justify-content: initial;
    width: auto;
  }
`

const Item = styled.div`
  flex: 1 1 0px;
  text-align: center;
  max-width: 330px;
  margin-left: 5px;
  margin-right: 5px;

  @media ${mobile.query} {
    align-items: flex-start;
    max-width: initial;
    text-align: left;

    &:nth-child(2n) {
      text-align: right;
      align-items: flex-end;
    }

    && > * {
      margin-left: 0;
      margin-right: 0;
    }
  }
`

const ItemImgContainer = styled.div`
  align-items: baseline;
  display: flex;
  justify-content: center;
  height: 214px;
  width: 100%;

  & img {
    max-height: 100%;
    max-width: 100%;
    min-width: 200px;
  }
`

const ItemTitle = styled.h3`
  margin: 32px;

  @media ${mobile.query} {
    margin: 14px;
  }
`

const ItemDescription = styled.p`
  & b {
    font-weight: bold;
  }

  @media ${mobile.query} {
    margin-bottom: 70px;
  }
`

const ReferenceText = styled.h5`
  color: #828282;
  font-size: 14px;
  font-style: italic;
  font-weight: normal;
  line-height: 24px;
  margin-top: 6px;
  text-align: center;

  @media ${mobile.query} {
    margin-top: -46px;
    text-align: left;
  }
`

const USE_CASES_LIST: UseCase[] = [
  {
    title: 'Messaging',
    imgSrc: messagingImg,
    description: (
      <>
        Clips, Stickers, Custom Text and GIFs are perfect for messaging or chatting one to one in
        the DMs.
      </>
    ),
  },
  {
    title: 'Creation',
    imgSrc: creationImg,
    description: (
      <>
        Easily enable creation in your app. Animate, layer, and react with the push of a button
        using our inspiring content library.
      </>
    ),
  },
  {
    title: 'Posting',
    imgSrc: postingImg,
    description: (
      <>
        Help your users post like a pro. I’ts a fact; Posts with Clips, Stickers, and GIFs get{' '}
        <b>*167% more click through</b> than static images!
      </>
    ),
  },
]

export const UseCasesBlock: React.FC = () => {
  return (
    <SectionBlock>
      <ItemsContainer>
        {USE_CASES_LIST.map((useCase) => (
          <Item key={useCase.title}>
            <ItemImgContainer>
              <img alt="" src={useCase.imgSrc} />
            </ItemImgContainer>
            <ItemTitle>{useCase.title}</ItemTitle>
            <ItemDescription>{useCase.description}</ItemDescription>
          </Item>
        ))}
      </ItemsContainer>
      <ReferenceText>
        *Ellerling, Nathan. “30 Social Media Engagement Tactics That Will Boost Shares And
        Conversions” CoSchedule Blog, August 5, 2015.
        www.coschedule.com/blog/social-media-engagement-tactics. Accessed 6 Oct 2021
      </ReferenceText>
    </SectionBlock>
  )
}
